import Insured from './Insured'

export default Insured
